module.exports = __webpack_public_path__ + "img/DS_DemonicSword.8724da04.png";